import BaseComponent from '../BaseComponent/BaseComponent';
import { Pagination } from 'antd';

export default class FPagination extends BaseComponent {
  renderComponent() {
    return <Pagination {...this.restProps} style={this.style} />;
  }
}
